import { PageLayout } from '../components/PageLayout'

export function LGPD() {
  return (
    <PageLayout title="Política LGPD - Direitos do Titular" lastUpdated="17 de Janeiro de 2025">
      <section>
        <h2>1. Sobre Esta Política</h2>
        <p>
          Esta política detalha os direitos que você possui como titular de dados pessoais,
          conforme estabelecido pela Lei Geral de Proteção de Dados (Lei nº 13.709/2018 - LGPD).
          O SecBrain Neurodivergente está comprometido em garantir o exercício pleno desses direitos.
        </p>
      </section>

      <section>
        <h2>2. Quem é o Controlador de Dados</h2>
        <p>
          <strong>Secbrain Inteligencia Artificial Tecnologia LTDA</strong><br />
          CNPJ: 52.234.008/0001-16<br />
          Endereço: Avenida Júlia Freire, 1200, Sala 109/110/111/112, Expedicionários, João Pessoa - PB, CEP 58041-000<br />
          E-mail do DPO: <a href="mailto:info@secbra.in">info@secbra.in</a>
        </p>
      </section>

      <section>
        <h2>3. Seus Direitos como Titular</h2>
        <p>
          A LGPD garante aos titulares de dados pessoais os seguintes direitos, que você pode
          exercer a qualquer momento:
        </p>

        <h3>3.1. Confirmação e Acesso</h3>
        <p>
          Você tem direito a confirmar se tratamos seus dados pessoais e, em caso afirmativo,
          acessar esses dados. Forneceremos uma cópia completa das informações que mantemos sobre você.
        </p>

        <h3>3.2. Correção</h3>
        <p>
          Você pode solicitar a correção de dados pessoais incompletos, inexatos ou desatualizados.
          Também é possível atualizar diretamente alguns dados através do seu painel na plataforma.
        </p>

        <h3>3.3. Anonimização, Bloqueio ou Eliminação</h3>
        <p>
          Você pode solicitar a anonimização, bloqueio ou eliminação de dados desnecessários,
          excessivos ou tratados em desconformidade com a LGPD.
        </p>

        <h3>3.4. Portabilidade</h3>
        <p>
          Você tem direito a receber seus dados em formato estruturado, de uso comum e leitura
          automática, para transferência a outro fornecedor de serviço, mediante requisição expressa.
        </p>

        <h3>3.5. Eliminação dos Dados</h3>
        <p>
          Você pode solicitar a eliminação dos dados pessoais tratados com base no seu consentimento,
          exceto nas hipóteses de retenção obrigatória previstas em lei.
        </p>

        <h3>3.6. Informação sobre Compartilhamento</h3>
        <p>
          Você tem direito a saber com quais entidades públicas e privadas compartilhamos seus dados.
        </p>

        <h3>3.7. Revogação do Consentimento</h3>
        <p>
          Quando o tratamento for baseado no consentimento, você pode revogá-lo a qualquer momento,
          de forma gratuita e facilitada. A revogação não afeta a legalidade do tratamento realizado anteriormente.
        </p>

        <h3>3.8. Oposição</h3>
        <p>
          Você pode se opor ao tratamento realizado com base em hipóteses de dispensa de consentimento,
          caso discorde da forma como tratamos seus dados.
        </p>

        <h3>3.9. Revisão de Decisões Automatizadas</h3>
        <p>
          Você pode solicitar a revisão de decisões tomadas unicamente com base em tratamento
          automatizado de dados pessoais que afetem seus interesses.
        </p>
      </section>

      <section>
        <h2>4. Como Exercer Seus Direitos</h2>
        <p>
          Para exercer qualquer um dos direitos acima, você pode:
        </p>

        <h3>4.1. Canal Preferencial</h3>
        <p>
          Envie um e-mail para <a href="mailto:info@secbra.in">info@secbra.in</a> com:
        </p>
        <ul>
          <li>Seu nome completo</li>
          <li>E-mail cadastrado na plataforma</li>
          <li>Descrição clara do direito que deseja exercer</li>
          <li>Documento de identidade (para verificação)</li>
        </ul>

        <h3>4.2. Através da Plataforma</h3>
        <p>
          Algumas solicitações podem ser feitas diretamente pelo seu painel de configurações,
          como atualização de dados cadastrais e preferências de comunicação.
        </p>

        <h3>4.3. Prazo de Resposta</h3>
        <p>
          Responderemos sua solicitação em até 15 (quinze) dias, conforme previsto na LGPD.
          Em casos complexos, podemos solicitar prazo adicional, sempre com justificativa.
        </p>
      </section>

      <section>
        <h2>5. Dados de Pacientes</h2>
        <p>
          Para dados de pacientes cadastrados na plataforma:
        </p>
        <ul>
          <li>
            <strong>Profissionais de saúde</strong> são corresponsáveis pelo tratamento e devem
            garantir os direitos dos titulares (pacientes e familiares)
          </li>
          <li>
            <strong>Pacientes ou responsáveis</strong> podem exercer seus direitos diretamente
            junto ao profissional de saúde ou através do nosso canal de DPO
          </li>
          <li>
            Solicitações de exclusão devem considerar obrigações legais de retenção de
            registros médicos
          </li>
        </ul>
      </section>

      <section>
        <h2>6. Retenção Obrigatória</h2>
        <p>
          Alguns dados não podem ser excluídos imediatamente devido a obrigações legais:
        </p>
        <ul>
          <li><strong>Registros fiscais:</strong> 5 anos (legislação tributária)</li>
          <li><strong>Registros de saúde:</strong> conforme regulamentação do CFM/CRP</li>
          <li><strong>Dados para defesa em processos:</strong> até prescrição do direito de ação</li>
        </ul>
      </section>

      <section>
        <h2>7. Segurança dos Dados</h2>
        <p>
          Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados:
        </p>
        <ul>
          <li>Criptografia em trânsito (TLS 1.3) e em repouso (AES-256)</li>
          <li>Autenticação segura com opção de múltiplos fatores</li>
          <li>Controle de acesso baseado em perfis</li>
          <li>Monitoramento e logs de auditoria</li>
          <li>Servidores em território brasileiro</li>
          <li>Backups criptografados e testados regularmente</li>
        </ul>
      </section>

      <section>
        <h2>8. Incidentes de Segurança</h2>
        <p>
          Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos
          titulares, comunicaremos:
        </p>
        <ul>
          <li>A Autoridade Nacional de Proteção de Dados (ANPD)</li>
          <li>Os titulares afetados, quando aplicável</li>
        </ul>
        <p>
          A comunicação será feita em prazo razoável, conforme regulamentação da ANPD.
        </p>
      </section>

      <section>
        <h2>9. Autoridade Nacional de Proteção de Dados</h2>
        <p>
          Se você acredita que seus direitos não foram atendidos adequadamente, pode
          apresentar reclamação à ANPD:
        </p>
        <ul>
          <li>Site: <a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer">www.gov.br/anpd</a></li>
          <li>E-mail: anpd@anpd.gov.br</li>
        </ul>
      </section>

      <section>
        <h2>10. Encarregado de Proteção de Dados (DPO)</h2>
        <p>
          Nosso Encarregado de Proteção de Dados está disponível para:
        </p>
        <ul>
          <li>Receber reclamações e comunicações dos titulares</li>
          <li>Receber comunicações da ANPD</li>
          <li>Orientar sobre práticas de proteção de dados</li>
        </ul>
        <p>
          <strong>Contato:</strong><br />
          E-mail: <a href="mailto:info@secbra.in">info@secbra.in</a><br />
          Endereço: Avenida Júlia Freire, 1200, Sala 109/110/111/112, Expedicionários, João Pessoa - PB, CEP 58041-000
        </p>
      </section>

      <section>
        <h2>11. Atualizações</h2>
        <p>
          Esta política pode ser atualizada para refletir mudanças em nossas práticas ou
          na legislação aplicável. Alterações significativas serão comunicadas através
          dos canais apropriados.
        </p>
      </section>
    </PageLayout>
  )
}
